import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { ReferenceService } from '../../services/reference.service';
import { MenuLink } from '../../models/navigation/menu-link.model';
import { SIDEBAR_STRUCTURE } from './sidebar-structure';
import { UserInfoModel } from 'src/app/models/userInfo.model';
import { RouteType } from 'src/app/models/navigation/route-type.enum';
import { Router } from '@angular/router';
import { RightsService } from 'src/app/services/rights.service';

@Component({
  selector: 'fs-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.sass'],
  encapsulation: ViewEncapsulation.None
})

export class SidebarComponent implements OnInit {
  sidebarStructure: MenuLink[] = SIDEBAR_STRUCTURE;

  constructor(
    public navigationService: NavigationService,
    private referenceService: ReferenceService,
    private router: Router,
    private rightsService: RightsService
  ) { }

  ngOnInit() {
    this.sidebarStructure = this.checkAccessRights();
  }

  changeRoute(event: any): void {
    if (!event.detail) {
      return;
    }

    if (event.detail.targetBlank) {
      // Make sure we take the external url to route outside the app
      const externalUrl = this.navigationService.getActivableLinksData().find(item => item.code === event.detail.id)
        .app.url;
      window.open(externalUrl);
      return;
    }

    this.router.navigate([event.detail.route]);
  }

  private checkAccessRights(): MenuLink[] {
    return this.sidebarStructure.filter(
      menu => !menu.accessRights || (menu.accessRights && menu.accessRights.every(right => this.rightsService.hasAccessRights(right)))
    );
  }

}
